import { Button } from '@common/components/Button';
import { Text } from '@common/components/Typography';
import styled from 'styled-components';

export const RecommendationsContainer = styled.div`
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding-right: 1rem;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
  background: ${({ theme }) => theme.defaultColors.lighterGrey};
`;

export const StyledButton = styled(Button)`
  display: inline-block;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 8px 16px;
  width: auto;
`;

export const TextAndButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const RecommendationText = styled(Text)`
  text-decoration: underline;
  font-size: 12px;
`;

export const RecommendationBox = styled.div``;
